import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { RegularPaymentInstructionDispatcher } from "./Variable";

export interface InstructionStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
    hasCashIsa?: boolean;
}

export class RegularPaymentInstructionStatic extends BaseStore<InstructionStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(RegularPaymentInstructionDispatcher, (actionData) =>
            this.onRegularPaymentInstructionStoreResponse(actionData)
        );
    }

    public getLastResult(): InstructionStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading === undefined ? true : this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }
    public getHasCashIsa() {
        return this.getState().hasCashIsa;
    }
    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): InstructionStaticState {
        return { actionType: ActionType.Loading, data: null, hasCashIsa: false };
    }

    private onRegularPaymentInstructionStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ isLoading: false, actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: actionData.actionType, hasCashIsa: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
